<template>
  <form enctype="multipart/form-data">
    <div class="grid grid--rev">
      <div class="grid__cell col5-of-12--large-up"></div>
      <div class="grid__cell col7-of-12--large-up">
        <p class="fw-bold fs-md mb-sm">Images</p>
        <div class="grid mb-sm">
          <div class="grid__cell col9-of-12--medium-up">
            <FileUploadZone
              zone-text="Upload or drop here your logo"
              storePath="settings/branding"
              :existingImg="data.logo"
              @update-image="updateImage"
              field="logo"
              help-text="A version of your logo for your Partner Card and PartnerPage, designed for a white background. It would be great if it has the following specs: transparent PNG image and 280px width / 140px height."
              accept=".png, .jpg, .jpeg, .gif"
            ></FileUploadZone>
          </div>
        </div>
        <div class="grid mb-lg">
          <div class="grid__cell col9-of-12--medium-up">
            <FileUploadZone
              @update-image="updateImage"
              zone-text="Upload or drop here your favicon"
              field="favicon"
              :existingImg="data.favicon"
              help-text="For best results, use 32x32 images."
              storePath="settings/branding"
              accept=".png, .jpg, .jpeg, .gif"
            ></FileUploadZone>
          </div>
        </div>
        <div class="grid mb-lg">
          <div class="grid__cell col9-of-12--medium-up">
            <FileUploadZone
              @update-image="updateImage"
              zone-text="Upload or drop here your login background"
              :existingImg="data.loginBackground"
              field="loginBackground"
              help-text="For best results, use high-resolution images."
              storePath="settings/branding"
              accept=".png, .jpg, .jpeg, .gif"
            ></FileUploadZone>
          </div>
        </div>
        <p class="fw-bold fs-md mb-sm">Colors</p>
        <div style="display: flex; flex-wrap: wrap;">
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.actionPrimaryColor"
                @changeColor="colorChange"
                input-name="actionPrimaryColor"
                label="Primary color"
                help-text="Color for buttons and links."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.actionSecondaryColor"
                @changeColor="colorChange"
                input-name="actionSecondaryColor"
                label="Secondary color"
                help-text="Color for secondary components."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.bgPrimaryColor"
                @changeColor="colorChange"
                input-name="bgPrimaryColor"
                label="Background primary color"
                help-text="Main background color of your directory."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.bgSecondaryColor"
                @changeColor="colorChange"
                input-name="bgSecondaryColor"
                label="Background secondary color"
                help-text="Secondary background color of your directory."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.textDarkColor"
                @changeColor="colorChange"
                input-name="textDarkColor"
                label="Text dark color"
                help-text="Used in title elements."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.textMediumColor"
                @changeColor="colorChange"
                input-name="textMediumColor"
                label="Text medium color"
                help-text="Used in main content."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.textLightColor"
                @changeColor="colorChange"
                input-name="textLightColor"
                label="Text light color"
                help-text="Used in secondary content."
              ></ColorInput>
            </div>
          </div>
          <div class="grid mb-md">
            <div class="grid__cell col6-of-12--medium-up" style="width: 75%;">
              <ColorInput
                :value="data.borderColor"
                @changeColor="colorChange"
                input-name="borderColor"
                label="Border color"
                help-text="Color for borders and dividers."
              ></ColorInput>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import FileUploadZone from '@/components/Dashboard/FileUploadZone';
import ColorInput from '@/components/Dashboard/ColorInput';

export default {
  components: {
    FileUploadZone,
    ColorInput,
  },
  props: {
    data: Object,
  },
  methods: {
    colorChange(payload) {
      this.$emit('color-change', payload);
    },
    updateImage(payload) {
      this.$emit('update-image', payload);
      this.$emit('dirty-tab');
    },
  },
};
</script>

<style lang="scss" scoped>
.grid .mb-md {
  width: 50%;
}
</style>
